<div class="header">
  <div class="title">
    <mat-label [routerLink]="['/admin']" routerLinkActive="router-link-active">
      <fa-icon [icon]="faChevronLeft"></fa-icon>
      <h2>Liste des films</h2>
    </mat-label>
  </div>
  <!-- <div class="toggle">
      <mat-slide-toggle color="primary" [checked]="isFilm" (change)="onChange($event)">Films en cours</mat-slide-toggle>
  </div> -->

</div>
<div class="cards" *ngIf="!detailRate">
  <mat-card *ngFor="let movie of listmovies" (click)="goToRate(movie)">
    <mat-card-header>
      <mat-card-title>{{ movie.title }}</mat-card-title>
    </mat-card-header>
    <div class="flex-div">
      <img mat-card-lg-image [src]="movie.attach" />

    </div>
  </mat-card>
</div>
